import React, { useState, useMemo, useRef, useContext } from "react";
import { useDropzone } from "react-dropzone";
import "./dropzone.css";
import bgImage from "./assets/dropzoneBGImage.png";
// import captureVideoFrame from "capture-video-frame";
import DATA_PRODUCTS from "./DATA_PRODUCTS";

import OpacityContext from "./OpacityContext";

// const baseStyle = {
//   // border: "#f5f5f5 dashed 2px"
//   border: "#ff1744 dashed 2px"
// };

const acceptStyle = {
  boxShadow: "0px 0px 8px 1px #00e676"
};

const rejectStyle = {
  boxShadow: "0px 0px 8px 1px #ff1744"
};
const dzBackgroundImage = {
  width: "100%",
  height: "100%",
  backgroundImage: `url(${bgImage})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  position: "absolute",
  zIndex: "100"
};

export default function DropzoneSimple({
  acceptedFileTypeString,
  assetFileToChange,
  droppedFileType,
  handleWarningMessageText,
  handleDropzoneChanges,
  handleContinueButtonDisabled
}) {
  /////////////////////////////  files accepted and message on mouse over

  const { productIndex, shakeDropzoneBGImage } = useContext(OpacityContext);

  const acceptedFileTypeMessageString = getHintString(acceptedFileTypeString);
  const ref = useRef(null);

  function getHintString(str) {
    let newString = str.split(",");
    let stringArrayMap = newString.map(function(value) {
      let split = value.split("/");
      return split[1];
    });
    return "accepted files: " + stringArrayMap.join(", ");
  }

  //////////////////////////////

  const [showHint, setShowHint] = useState(false);
  const [files, setFiles] = useState([]);
  // Support external file preview for parent-driven workflows
  const externalFile =
    assetFileToChange && assetFileToChange.payload
      ? assetFileToChange.payload
      : null;
  // Combine local files and externalFile for preview
  const previewFiles = externalFile
    ? [
        Object.assign(externalFile, {
          preview: URL.createObjectURL(externalFile)
        })
      ]
    : files;

  const validateDroppedFile = (w, h) => {
    const expectedPixelsE = DATA_PRODUCTS.data[productIndex].pixels.ePixels;
    const expectedPixelsL = DATA_PRODUCTS.data[productIndex].pixels.lPixels;
    const expectedPixelsP = DATA_PRODUCTS.data[productIndex].pixels.pPixels;

    const expectedSizeE =
      DATA_PRODUCTS.data[productIndex].acceptedSizeText.eSizes;
    const expectedSizeL =
      DATA_PRODUCTS.data[productIndex].acceptedSizeText.lSizes;
    const expectedSizeP =
      DATA_PRODUCTS.data[productIndex].acceptedSizeText.pSizes;
    let expectedPixels;

    droppedFileType === "elevator"
      ? (expectedPixels = expectedPixelsE)
      : droppedFileType === "landscape"
      ? (expectedPixels = expectedPixelsL)
      : (expectedPixels = expectedPixelsP);

    let acceptedSizes;

    droppedFileType === "elevator"
      ? (acceptedSizes = expectedSizeE)
      : droppedFileType === "landscape"
      ? (acceptedSizes = expectedSizeL)
      : (acceptedSizes = expectedSizeP);

    const receivedPixels = w * h;
    console.log("expected = ", expectedPixels);
    console.log("received = ", receivedPixels);

    const exists = Object.values(expectedPixels).includes(receivedPixels);

    if (droppedFileType === "svg" || droppedFileType === "standardAd") {
      handleWarningMessageText("", false);
      return true;
    } else if (exists) {
      handleWarningMessageText("", false);
      return true;
    } else {
      handleWarningMessageText(
        `dropped file is wrong size. Requred dimensions: ${acceptedSizes}`,
        true
      );
      return false;
    }
  };

  //* removed unused vars from const object useDropzone():acceptedFiles,fileRejections,isDragActive,
  const {
    getRootProps,
    getInputProps,
    isDragAccept,
    isDragReject
  } = useDropzone({
    maxFiles: 1,
    noClick: false,
    multiple: false,
    accept: acceptedFileTypeString,

    onDropRejected: rejectedFiles => {
      setFiles([]);
      handleWarningMessageText("wrong file type dropped.", true);
    },
    onDropAccepted: acceptedFiles => {
      const newFile = acceptedFiles[0];
      const previewUrl = URL.createObjectURL(newFile);
      const nameArray = newFile.name.split(".");
      const ext = nameArray[nameArray.length - 1];

      if (ext !== "mp4") {
        const i = new Image();
        i.onload = () => {
          let reader = new FileReader();
          reader.readAsDataURL(newFile);
          reader.onload = () => {
            const droppedFileIsCorrectSize = validateDroppedFile(
              i.width,
              i.height
            );
            if (droppedFileIsCorrectSize) {
              setFiles([
                Object.assign(newFile, {
                  preview: previewUrl
                })
              ]);
              handleDropzoneChanges("name", newFile.name, droppedFileType);
              handleDropzoneChanges("payload", newFile, droppedFileType);
              handleDropzoneChanges("width", i.width, droppedFileType);
              handleDropzoneChanges("height", i.height, droppedFileType);
              handleDropzoneChanges("type", newFile.type, droppedFileType);
              handleDropzoneChanges("size", newFile.size, droppedFileType);
            } else {
              URL.revokeObjectURL(previewUrl);
              setFiles([]);
            }
          };
        };

        i.src = previewUrl;
      } else {
        // need to interrogate video for its secrets
        const video = document.createElement("video");
        video.addEventListener("canplay", event => {
          const droppedFileIsCorrectSize = validateDroppedFile(
            video.videoWidth,
            video.videoHeight
          );
          if (droppedFileIsCorrectSize) {
            setFiles([
              Object.assign(newFile, {
                preview: previewUrl
              })
            ]);
            handleDropzoneChanges("payload", newFile, droppedFileType);
            handleDropzoneChanges("width", video.videoWidth, droppedFileType);
            handleDropzoneChanges("height", video.videoHeight, droppedFileType);
            handleDropzoneChanges("type", newFile.type, droppedFileType);
            handleDropzoneChanges("size", newFile.size, droppedFileType);
            handleDropzoneChanges("name", newFile.name, droppedFileType);
          } else {
            URL.revokeObjectURL(previewUrl);
            setFiles([]);
          }
        });
        video.src = previewUrl;
      }
    }
  });

  const style = useMemo(
    () => ({
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragAccept, isDragReject]
  );

  // Unified preview rendering
  const svgImagePreview = previewFiles.map(file => (
    <img
      key={file.name}
      src={file.preview}
      style={{ width: "100%" }}
      alt="preview"
    />
  ));

  const imagePreview = previewFiles.map(file => (
    <img
      key={file.name}
      src={file.preview}
      style={{ width: "100%" }}
      alt="preview"
    />
  ));

  const videoPreview = previewFiles.map(file => (
    <video key={file.name} loop style={{ width: "100%" }}>
      <source src={file.preview} />
    </video>
  ));

  return (
    <div
      className="dropzoneImageGrandParent"
      onMouseEnter={() => setShowHint(true)}
      onMouseLeave={() => setShowHint(false)}
    >
      {showHint ? (
        <div className="dropzoneHint">{acceptedFileTypeMessageString}</div>
      ) : null}
      <div {...getRootProps({ style })} className="dropZone newBaseStyle">
        <div className="droppedImageHolder">
          {previewFiles.length === 0 ? (
            <div
              style={dzBackgroundImage}
              className={`dzBackgroundImage ${
                shakeDropzoneBGImage ? "shakeIt" : ""
              }`}
            ></div>
          ) : null}
          <div ref={ref} className="dropzoneImageParent">
            {externalFile &&
            externalFile.type &&
            externalFile.type.includes("video")
              ? videoPreview
              : droppedFileType === "svg"
              ? svgImagePreview
              : imagePreview}
          </div>
        </div>

        <input {...getInputProps()} />
      </div>
    </div>
  );
}
